export const ASSESMENT_QUESTION_TYPE = {
  HEALTH_INFO: 'Health Info (พื้นฐาน)',
  ACTIVITIES: 'Activities (กิจกรรม)',
  FOOD_AND_EATING_HABITS: 'Food and eating habits (อาหาร และนิสัยการรับประทาน)',
  ATTITUDE: 'Attitude (ทัศนคติ)',
  SLEEP: 'Sleep (การนอน)',
  STRESS: 'Stress (ความเครียด)',
  OTHERS: 'Others (ความสนใจเฉพาะด้าน)',
};

export const ASSESMENT_QUESTION_TYPE_VALUE = {
  HEALTH_INFO: 'HealthInfo',
  ACTIVITIES: 'Activities',
  FOOD_AND_EATING_HABITS: 'FoodHabits',
  ATTITUDE: 'Attitude',
  SLEEP: 'Sleep',
  STRESS: 'Stress',
  OTHERS: 'Others',
};

export const HEALTH_INFO_PARAMS = {
  BMI: 'BMI',
  Waistline: 'Waistline',
};

export const bmiDefaultValues = [
  'A. Less than 18.5',
  'B. 18.5-22.9',
  'C. 23.0-24.9',
  'D. 25.0-29.9',
  'E. More than 30',
];

export const waistlineDefaultValues = [
  'A. Male, less than 35',
  'B. Male, 35-38',
  'C. Male, more than 38',
  'D. Female, less than 31',
  'E. Female, 31-35',
  'F. Female, more than 35',
];

export const STATUS = {
  PUBLISH: 'Published',
  UNPUBLISH: 'Unpublished',
  DELETE: 'DELETE',
};

export const MAX_ORDER_FLEX_PUBLISH_LIMIT =
  'ไม่สามารถอัพเดตได้ เนื่องจากมีจำนวนเนื้อหาที่มีสถานะ Publish เกิน 12 จำนวน';

export const ENV_TYPE = {
  OA: 'OA',
  CATEGORY: 'CAT',
  GROUP: 'GROUP',
  SUB_CATEGORY: 'SUBCAT',
  LIB_CATEGORY: 'LIBCAT',
  LIB_SUB_CATEGORY: 'LIBSUBCAT',
};
export const LIST_FOOD_BUTTONS = {
  reset: 'Reset',
  search: 'Search',
  keyword: 'Keyword',
  data_not_found: ' Data Not Found',
  submit: 'Submit',
  back: 'Back',
  status: 'เลือกสถานะ',
  publish: "PUBLISH",
  unpublish: 'UNPUBLISH',
  foodCat: 'เลือก',
  food: 'Food',
  supplement: 'Supplement',
  img_dimension: '*ขนาดรูปภาพ 1000 x 1000 (.jpg, .png)',
  null_checks_and_errors: 'กรุณาเพิ่มรายละเอียดให้ครบถ้วน',
}
export const LIST_FOOD_CAT = {
  sno: '#',
  categoryImage: 'Category Image',
  tagImage: 'Tag Image',
  categoryName: 'Food Name',
  createdDate: 'Created Date',
  updatedDate: 'Updated Date',
  statusHeader: 'Status',
  nameLabel: 'ชื่อ',
  creationDate: 'วันที่สร้าง',
  to: 'ถึง',
  statusLabel: 'สถานะ',
  create: 'Create Flex',
  reorder: 'Reorder Flex',
}
export const LIST_FOOD_CAT_CREATE = {
  create: 'Create Food Category',
  foodCatName: 'Food Cat Name',
  foodCatImage: ' Image',
  chooseFile: 'Choose File',
  tagImage: 'Tag Image',
  statusLabel: 'Status',
  edit: 'Edit Food Category',
  foodCategoryImage: 'food-cat-image',
  foodCategoryTag: 'food-cat-tag'
}
export const LIST_FOOD_CAT_REORDER = {
  reorder: 'Reorder Food Category',
  orderNo: 'ลำดับที่'
}
export const LIST_FOOD_MENU = {
  nameLabel: 'ชื่อ',
  foodCatName: 'Food Cat',
  creationDate: 'วันที่สร้าง',
  to: 'ถึง',
  statusLabel: 'สถานะ',
  reset: 'Reset',
  search: 'search',
  keyword: 'Keyword',
  create: 'Create',
  sno: '#',
  foodImage: 'Food Image',
  foodCat: 'Food Category',
  menu: 'Menu',
  createdDate: 'Created Date',
  updatedDate: 'Updated Date',
  statusHeader: 'Status',
}
export const LIST_FOOD_MENU_CREATE = {
  create: 'Create Food',
  foodName: 'Food Name',
  foodImage: 'Image',
  chooseFile: 'Choose File',
  foodCatName: 'Food Category',
  quantity: 'Quantity',
  unit: 'Unit',
  weight: 'Weight',
  calorie: 'Calorie',
  carbs: 'Carbohydrates (g)',
  protein: 'Protein (g)',
  fat: 'Fat (g)',
  recommend: 'Recommend',
  statusLabel: 'Status',
  edit: 'Edit Food',
}

export const LIST_FOOD_MENU_CREATE_ABO = {
  create: 'Create Food',
  foodName: 'Food Name',
  foodImage: 'Image',
  chooseFile: 'Choose File',
  foodCatName: 'Food Category',
  quantity: 'Quantity',
  unit: 'Unit',
  weight: 'Food Weight',
  calorie: 'Calories',
  carbs: 'Carbohydrates',
  protein: 'Protein',
  fat: 'Fat',
  recommend: 'Recommend',
  statusLabel: 'Status',
  edit: 'Edit Food',
  content: 'Content',
  aboInfo: 'ABO information',
  adaNo: 'ADA number',
  name: 'Name :',
  createdDate: 'createdDate : ',
  updateDate: 'updateDate : ',
  delete: 'Delete'
}

export const LIST_SUPPLEMENT = {
  nameLabel: 'ชื่อ',
  publish: 'Publish',
  unpublish: 'Unpublish',
  creationDate: 'วันที่สร้าง',
  to: 'ถึง',
  statusLabel: 'สถานะ',
  reset: 'Reset',
  search: 'search',
  keyword: 'Keyword',
  create: 'Create',
  sno: '#',
  supplementImage: 'Supplement Image',
  supplementName: 'Supplement Name',
  items: 'Items#',
  createdDate: 'Created Date',
  updatedDate: 'Updated Date',
  statusHeader: 'Status',
}

export const LIST_SUPPLEMENT_CREATE = {
  create: 'Create Supplement',
  supplementName: 'Supplement Name',
  suplementImage: 'Image',
  chooseFile: 'Choose File',
  items: 'Items#',
  quantity: 'Quantity',
  unit: 'Unit',
  weight: 'Weight',
  calorie: 'Calorie',
  carbohydrates: 'Carbohydrates (g)',
  protein: 'Protein (g)',
  fat: 'Fat (g)',
  statusLabel: 'Status',
  edit: 'Edit Supplement',
  recommend: 'Recommend',
  amwayClickProduct: 'Amway Click Product',
  consumptionQty: 'Consumption Quantity'
}

export const LIST_FOOD_MENU_ABO = {
  foodName: 'Food Name',
  nameContainer: 'name',
  adaNumber: 'ADA Number',
  aboNumber: 'aboNumber',
  creationDate: 'วันที่สร้าง',
  to: 'to',
  statusLabel: 'สถานะ',
  reset: 'Reset',
  search: 'search',
  contents: 'Contents',
  sno: '#',
  foodImage: 'Food Image',
  createDate: 'Create Date',
  updateDate: 'Update Date',
  statusHeader: 'Status',
}

export const LIST_FOOD_DELETE_TEXT = {
  delete: 'ยืนยันการลบข้อมูล ?'
}

export const LIST_EXCERCISE_CATEGORY = {
  nameLabel: 'ชื่อ',
  publish: 'Publish',
  unpublish: 'Unpublish',
  creationDate: 'วันที่สร้าง',
  to: 'ถึง',
  statusLabel: 'สถานะ',
  reset: 'Reset',
  search: 'search',
  keyword: 'Keyword',
  create: 'Create Flex',
  reorder: 'Reorder Flex',
  sno: '#',
  categoryImage: 'Category Image',
  categoryBanner: 'Category Banner',
  categoryName: 'Category Name',
  createdDate: 'Created Date',
  updatedDate: 'Updated Date',
  statusHeader: 'Status',
}

export const LIST_EXCERCISE_CATEGORY_CREATE = {
  create: 'Create Exercise Category',
  edit: 'Edit Exercise Category',
  exerciseCatName: 'Exercise Cat Name',
  exerciseCatImage: 'Image',
  exerciseBannerImage: 'Banner Image',
  chooseFile: 'Choose File',
  exerciseCatImageTag: 'exercise-cat-img',
  exerciseBannerImageTag: 'banner-cat-img',
  statusLabel: 'Status',
  img_dimension: '*ขนาดรูปภาพ 600 x 600 (.jpg, .png)',
  banner_img_dimension: '*ขนาดรูปภาพ 889 x 430 (.jpg, .png)',
  duplicate: 'Please check, Duplicate Exercise Category'
}

export const LIST_EXERCISE_CAT_REORDER = {
  reorder: 'Reorder Exercise Category',
  orderNo: 'ลำดับที่'
}

export const LIST_EXERCISE_TEMPLATE_REORDER = {
  reorder: 'Reorder Exercise Template',
  orderNo: 'ลำดับที่'
}

export const LIST_EXCERCISE_MENU = {
  nameLabel: 'ชื่อ',
  foodCatName: 'Food Cat',
  creationDate: 'วันที่สร้าง',
  to: 'ถึง',
  statusLabel: 'สถานะ',
  reset: 'Reset',
  search: 'Search',
  keyword: 'Keyword',
  create: 'Create Flex',
  reorder: 'Reorder Flex',
  sno: '#',
  exerciseCat: 'Exercise Cat',
  exerciseTemp: 'Exercise Temp',
  exerciseMenu: 'Exercise Menu',
  exerciseImage: 'Exercise Image',
  createdDate: 'Created Date',
  updatedDate: 'Updated Date',
  statusHeader: 'Status',
  img_dimension: '*ขนาดรูปภาพ 600 x 600 (.jpg, .png)',
  duplicate: 'Please check, Duplicate exercise menu'
};

export const LIST_EXCERCISE_MENU_CREATE = {
  createHeader: 'Create Exercise Menu',
  editHeader: 'Edit Exercise Menu',
  exerciseName: 'Exercise Name',
  image: 'Image',
  exerciseCat: 'Exercise Category',
  exerciseTemp: 'Exercise Template',
  caloriesBurn: 'Calories (Burn) per Min/Time',
  suggestion: 'Suggestion (min)',
  suggestionList: 'Suggestion List',
  chooseFile: 'Choose File',
  back: 'Back',
  submit: 'Submit',
  imageTag: 'exercise-img',
  select: 'Select',
  statusLabel: 'Status'
};

export const LIST_EXERCISE_MENU_REORDER = {
  reorder: 'Reorder Exercise Menu',
  orderNo: 'ลำดับที่'
}

export const LIST_EXCERCISE_TEMP = {
  nameLabel: 'ชื่อ',
  creationDate: 'วันที่สร้าง',
  to: 'ถึง',
  statusLabel: 'สถานะ',
  reset: 'Reset',
  search: 'search',
  keyword: 'Keyword',
  create: 'Create Flex',
  reorder: 'Reorder Flex',
  sno: '#',
  tempName: 'Temp Name',
  tempBanner: 'Temp Banner',
  createdDate: 'Created Date',
  updatedDate: 'Updated Date',
  statusHeader: 'Status',
  duplicate: 'Please check, Duplicate exercise template'
}

export const LIST_EXCERCISE_TEMP_CREATE = {
  create: 'Create',
  edit: 'Edit',
  tempName: 'Exercise Template Name',
  bannerImage: 'Banner Image',
  chooseFile: 'Choose File',
  statusLabel: 'Status',
  bannerImageTag: 'banner-img',
  img_dimension: '*ขนาดรูปภาพ 24 x 24 (.jpg, .png)',
  banner_img_dimension: '*ขนาดรูปภาพ 889 x 430 (.jpg, .png)',
}

export const LIST_EXCERCISE_TEMP_INPUT = {
  inputTypeLabel: 'Input Type',
  selectInputLabel: 'เลือกประเภทอินพุต',
  selectDataField: 'Select',
  time: 'Time',
  calories: 'Calories',
  numpad: 'Numpad',
  startTextLabel: 'Start Text',
  textLabel: 'Text',
  endTextLabel: 'End Text',
  startImageLabel: 'Start Text Image',
  imageLabel: 'Image',
  chooseFile: 'Choose File',
  noFileChosen: 'No file chosen',
  endImageLabel: 'End Text Image',
  newSection: 'New Section',
  remove: 'Remove',
  dataField: 'Data Field',
  range: 'Range',
  min: 'Min',
  max: 'Max'
}

export const LIST_EXERCISE_NUMPAD_DROPDOWN = [
  { label: 'ระยะทาง (กิโลเมตร)', value: 'distCovered' },
  { label: 'ความเร็วเฉลี่ย (นาที/กิโลเมตร)', value: 'avgSpeed' },
  { label: 'ความชันสะสม (กิโลเมตร)', value: 'slope' },
  { label: 'อัตราการเต้นหัวใจเฉลี่ย (bpm)', value: 'avgHeartRate' },
  { label: 'อัตราการเต้นหัวใจสูงสุด (bpm)', value: 'maxHeartRate' },
  { label: 'ระดับความหน่วง', value: 'latencyLevel' },
  { label: 'รอบขา (spm)', value: 'cadence' },
  { label: 'จำนวนครั้ง', value: 'noOfTimes' }
]

export const IMAGE_ERROR_EXTENSION = 'ไฟล์รูปภาพไม่ถูกต้อง';
export const IMAGE_ERROR_NOT_FOUND = 'กรุณาเพิ่มไฟล์รูปภาพให้ครบถ้วน';
export const IMAGE_ERROR_DIMENSIONS = 'รูปภาพต้องมีขนาด 600 x 600 pixels';
export const IMAGE_ERROR_DIMENSIONS_FOOD = 'รูปภาพต้องมีขนาด 1000 x 1000 pixels';
export const IMAGE_ERROR_DIMENSIONS_EXERCISE_BANNER = 'รูปภาพต้องมีขนาด 889 x 430 pixels';
export const IMAGE_ERROR_DIMENSIONS_EXERCISE_TEMPLATE = 'รูปภาพต้องมีขนาด 24 x 24 pixels';

export const imageTypeList = ['jpg', 'jpeg', 'png'];
export const regexForScoreTitle = /[^\u0E00-\u0E3E\u0E40-\u0E7Fa-zA-Z\s]/;
export const regexForScore = /^\d*$/;
export const regexForString = /^[ก-๙a-zA-Z ]*$/;


export const userTypes = {
  ABO: 'abo',
  MEMBER: 'member',
  ALL: 'all'
};

export const userListType = [
  { label: "All", value: "all" },
  { label: "ABO", value: "abo" },
  { label: "Member", value: "member" }
];

export const HEALTHINFO = 'HealthInfo'
export const OTHERS = 'Others'

export const KEYBOARD_KEYS = {
  backspace: 'Backspace',
  arrowLeft: 'ArrowLeft',
  arrowRight: 'ArrowRight',
  delete: 'Delete',
  tab: 'Tab'
}

export const LIST_EXERCISE = {
  name: 'name',
  nameErr: 'กรุณาใส่ Exercise Name',
  category: 'category',
  categoryErr: 'กรุณาใส่ Exercise Category',
  template: 'template',
  templateErr: 'กรุณาใส่ Exercise Template',
  calories: 'calories',
  caloriesErr: 'กรุณาใส่ Calories Burn',
  suggestion: 'suggestion',
  suggestionErr: 'กรุณาใส่ Suggestion',
  title: 'title',
  titleErr: 'กรุณาใส่ Title',
  status: 'status',
  statusErr: 'กรุณาใส่ Status',
  inputList: 'inputList',
  inputListErr: 'กรุณาใส่ inputList',
  fieldTypeErr: 'กรุณาใส่ Field Type',
  minRangeErr: 'กรุณาใส่ Min Range',
  maxRangeErr: 'กรุณาใส่ Max Range',
  minMaxCompareError: 'Max range cannot be less than min range',
  endTextErr: 'กรุณาใส่ End Text',
  startTextErr: 'กรุณาใส่ Start Text',
  inputTypeErr: 'กรุณาใส่ Input Type'
}

export const SKIN_ASSESMENT_QUESTION_TYPE = {
  CARD_SKIN_TYPE: 'Card Skin Type',
  CARD: 'Card',
  BAR: 'Bar',
  TEXT_SINGLE: 'Text - Single',
  TEXT_MULTIPLE: 'Text - Multiple',
};

export const SKIN_ASSESMENT_QUESTION_TYPE_VALUE = {
  CARD_SKIN_TYPE: 'Card - Skin Type',
  CARD: 'Card',
  BAR: 'Bar',
  TEXT_SINGLE: 'TextSingle',
  TEXT_MULTIPLE: 'TextMultiple',
};

export const SKIN_TYPE_INFO_PARAMS = {
  SKIN_TYPE: 'Skintype',
  SKIN_TYPE_NOT_SURE: 'Skintype-notsure',
};

export const ASSESSMENT_LABEL = {
  LIFESTYLE_ASSESSMENT: '6LifestyleKeysAssesment',
  SKIN_ASSESSMENT: 'skinAssessment',
  STRESS_ASSESSMENT: 'stressAssessment',
  GUT_ASSESSMENT: 'gutAssessment',
}

export const QUESTION_LABEL = {
  m1: 'M1',
  m1_e: 'M1.E',
  m5_products: 'M5.Q_PRODUCTS',
}

